export class Industry {
  constructor(
    private id: IndustryId,
    public name: string
  ) { }

  public getId(): IndustryId {
    return this.id;
  }
}

export type IndustryId = string;



// WEBPACK FOOTER //
// /dist/src/app/user/work-record/industry.model.ts